import { Component, EventEmitter, Input, OnInit, Output, NgModule, OnDestroy, ChangeDetectorRef, AfterViewInit, Renderer2, ElementRef } from '@angular/core';
import { ApiService } from '@services/api.service';
import { LocalizationService } from '@services/localization.service';
import { Location } from '@angular/common';

import { UiHelper } from '@helpers/ui.helper';
import { UserHelper } from '@helpers/user.helper';
import { TranslatePipe } from '@pipes/translate.pipe';
import { Router, ActivatedRoute } from '@angular/router';
import { OddModel } from './sports.component';
import { SignalrServiceLegacy } from '@services/signalr.service.legacy';
import { DataHelper } from '@helpers/data.helper';
import { DomSanitizer } from '@angular/platform-browser';
import { environment, getBetGeniusLiveTracker } from '@environments/environment';
import { HeadToHeadDialog } from './headtohead-dialog';
import { MatDialog } from '@angular/material/dialog';
import { Subscription } from 'rxjs';

declare let SIR: any;

declare global {
  interface Window {
    STATSCOREWidgets: any;
  }
}

@Component({
  selector: 'liveeventdetail-component',
  templateUrl: '../sharedTemplates/liveeventdetail.component.html',
})
export class LiveEventDetailComponent implements OnInit, OnDestroy, AfterViewInit {
  theme = '';

  // B3000
  @Input() eventIdByInput = 0;
  @Input() showLiveList = true;
  isFavorite = false;

  eventDetailTabItemSelected = 2;
  // B3000

  SIROBJ;
  widgetEl;

  openLiveTrackerIsActive = false;

  eventdetailList = [];
  eventdetailListOriginal = [];
  selectedMarketValue = 2;

  event;
  _selectedOdds: OddModel[] = [];
  enableScoreBox = true;
  enableBetGeniusTracker = false;
  betgeniustrackerlink: any;

  eventid = 0;
  private subscriptionsToStopOnDestroy: Subscription[] = [];

  constructor(
    private _location: Location,

    public _DataHelper: DataHelper,
    private _ApiService: ApiService,
    private _UiHelper: UiHelper,
    private _UserHelper: UserHelper,
    private _router: Router,
    private route: ActivatedRoute,
    public _LZ: LocalizationService,
    public _signalService: SignalrServiceLegacy,
    public _dataHelper: DataHelper,
    private _changeDetection: ChangeDetectorRef,
    private domSanitizer: DomSanitizer,
    public dialog: MatDialog,
    private ref: ChangeDetectorRef,
    private renderer: Renderer2,
    private elementRef: ElementRef
  ) {
    this.theme = this._UiHelper.getTheme();
    this._UiHelper.changeThemeListener.subscribe((x: any) => {
      this.theme = x;
    });

    if (this._DataHelper.selectedMatch !== undefined) {
      const favIndexOf = this._UserHelper.favoriedMatches.indexOf(this._DataHelper.selectedMatch.BetradarMatchId);

      if (favIndexOf > -1) this.isFavorite = true;
      else this.isFavorite = false;
    } else {
      this.isFavorite = false;
    }
  }
  public isTracerMapped = true;
  public lsTrackerWidget;
  subscriberoute;
  subscribesignalr;
  subscribeselectedodds;
  subscribelive;
  subscribeeventdetail;

  _isActiveSignalrConnectionListener: Subscription;
  ngOnInit() {
    if (this.eventIdByInput == 0) {
      this.subscriberoute = this.route.params.subscribe(params => {
        this.resetSubscriptions();

        this.eventid = params['eventid'];
        this.flagSIR = false;
        this.initialEventDetail();
      });
    } else {
      this.eventid = this.eventIdByInput;
      this.initialEventDetail();
    }
    this._ApiService.getSelectedOdds();
    this._isActiveSignalrConnectionListener = this._UiHelper.isActiveSignalrConnectionListener.subscribe(state => {
      this.signalLiveConnection(state);
    });
  }

  ngAfterViewInit() {
    this.renderTracker();
    if (environment.tracker_Operator === 'LS_Tracker' && this.eventid && this.eventid !== 0) {
      setTimeout(() => {
        this.renderLSTracker();
      }, 2000);
      if (environment.product === 'cangobet') {
        this.widgetEl = this.elementRef.nativeElement.querySelector('#lsSportWrapperElemCango');
        this.element = document.getElementById('lsSportWrapperElemCango');
      }

      this.renderer.listen(this.widgetEl, 'DOMSubtreeModified', event => {
        if (this.widgetEl.innerHTML === 'Widget could not be loaded.') {
          this.isTracerMapped = false;
        }
      });
    }
  }

  signalLiveConnection(state: boolean): void {
    if (state) {
      this.resetSubscriptions();
      this.initialEventDetail();
    } else {
      this.resetSubscriptions();
    }
  }

  initialEventDetail() {
    this.resetSubscriptions();

    //If connection is not exists
    if (!this._signalService.connectionExists) {
      this.subscribesignalr = this._signalService.connectionEstablished.subscribe(x => {
        this.subscribeHub();
      });
    } else {
      this.subscribeHub();
    }

    //Selected Odds Subscription
    this.subscribeselectedodds = this._ApiService.selectedOddsEvent.subscribe(x => {
      this._selectedOdds = x as OddModel[];
    });

    this._UiHelper.setNavbarTitle('LIVE');
  }

  iframesrc;
  flagSIR = false;
  subscribeHub() {
    //Signalr Subscription
    if (this.eventid != 0) {
      this._signalService.subscribeLiveEvent(this.eventid);
    }

    //Event Detail Odds Subscription
    this.subscribeeventdetail = this._dataHelper.liveEventDetailListener.subscribe(x => {
      this.eventdetailListOriginal = x;
      this.eventdetailList = x;
      // debugger;
      if (this.selectedMarketValue != 2) {
        this.eventdetailList = this.eventdetailList.filter(s => s.IsChanged == this.selectedMarketValue);
      }
      this._changeDetection.detectChanges();
    });

    this.renderTracker();

    this.subscribelive = this._dataHelper.liveDataListener.subscribe(y => {
      this.event = y.find(x => x.EventId == this.eventid);
      this._changeDetection.detectChanges();

      this.renderTracker();
    });
    this.renderLSTracker(this.eventid);
  }

  element;
  renderLSTracker(eventId?) {
    if (eventId == undefined) {
      eventId = this.eventid;
    }
    if (environment.product === 'cangobet') {
      this.element = document.getElementById('lsSportWrapperElemCango');
    }
    const groupId = environment.tracker_GroupId;
    const inputData = { eventId: `m:${eventId}`, language: 'en', providerId: environment.tracker_ProviderId };
    if (eventId.toString().includes('-')) {
      inputData.eventId = `m:${eventId.toString().split('-')[1]}`;
      inputData.providerId = 109;
    }
    const options = {};
    const widget = new window.STATSCOREWidgets.WidgetGroup(this.element, groupId, inputData, options);
    this.lsTrackerWidget = widget;
  }

  renderTracker() {
    //Event Detail Event Subscription
    if (this._dataHelper.liveData != undefined && !this.flagSIR) {
      this.flagSIR = true;
      this.event = this._dataHelper.liveData.find(x => x.EventId == this.eventid);
      try {
        if (SIR != undefined) {
          if (this.event != undefined && this.event.BetradarMatchId > 0) {
            this.SIROBJ = SIR('addWidget', '.sr-widget-1', 'match.lmtPlus', { layout: 'double', collapseTo: 'disable', pitchLogo: '', matchId: this.event.BetradarMatchId });
            if (this.SIROBJ) {
              this.enableScoreBox = false;
              this.enableBetGeniusTracker = false;
              this.isiframeloaded = false;
            } else {
              this.flagSIR = false;
            }
          } else {
            if (this.event != undefined) {
              this.betgeniustrackerlink = this.domSanitizer.bypassSecurityTrustResourceUrl(getBetGeniusLiveTracker(this.event.BetradarMatchId, this._LZ.LANGCODE));
              this.enableBetGeniusTracker = true;
              this.enableScoreBox = false;
              this.SIROBJ = SIR('removeWidget', '.sr-widget-1');
            } else {
              this.flagSIR = false;
            }
          }
        }
      } catch (e) {
        this.flagSIR = false;
        if (this.event != undefined && !this.iframesrc) {
          this.iframesrc = this.domSanitizer.bypassSecurityTrustResourceUrl('https://wettarena.de/tracker.html?e=' + this.event.BetradarMatchId);
        }
        this.isiframeloaded = true;
      }
    }
  }

  iframetr;
  isiframeloaded = false;
  frameheight = '410';
  ToogleLiveTracker() {
    window.scroll(0, 0);
    try {
      if (!this.openLiveTrackerIsActive && this.event != undefined) {
        this.SIROBJ = SIR('updateWidget', '.sr-widget-1', {
          collapseTo: 'disable',
          pitchLogo: 'https://wettarena.de/angular/dist/assets/images/logo.png',
          matchId: this.event.BetradarMatchId,
        });
        this.openLiveTrackerIsActive = true;
      } else {
        this.SIROBJ = SIR('addWidget', '.sr-widget-1', 'match.lmtPlus', {
          layout: 'single',
          collapseTo: 'momentum',
          pitchLogo: 'https://wettarena.de/angular/dist/assets/images/logo.png',
          matchId: this.event.BetradarMatchId,
        });
        this.openLiveTrackerIsActive = false;
      }
    } catch (e) {
      if (!this.openLiveTrackerIsActive) {
        if (environment.mobile) this.frameheight = '380';
        else this.frameheight = '380';

        this.openLiveTrackerIsActive = true;
      }
    }
  }

  framepageLoaded(e) {
    this.iframetr = e;
  }

  ngOnDestroy() {
    this.flagSIR = false;
    if (this.subscriberoute != undefined) {
      try {
        this.subscriberoute.unsubscribe();
      } catch (e) {
        console.log(e);
      }
    }

    if (this._isActiveSignalrConnectionListener) {
      this._isActiveSignalrConnectionListener.unsubscribe();
    }

    if (this.subscribeselectedodds != undefined) {
      try {
        this.subscribeselectedodds.unsubscribe();
      } catch (e) {
        console.log(e);
      }
    }
    for (const subscription of this.subscriptionsToStopOnDestroy) {
      if (subscription) {
        subscription.unsubscribe();
      }
    }
    this.resetSubscriptions();

    if (this.lsTrackerWidget && this.lsTrackerWidget.destroy) {
      try {
        this.lsTrackerWidget.destroy();
      } catch (e) {
        console.log(e);
      }
    }
  }

  resetSubscriptions() {
    this.SIROBJ = null;
    this._signalService.unSubscribeLiveEvent(this.eventid);
    try {
      if (this.subscribesignalr != undefined) {
        this.subscribesignalr.unsubscribe();
      }

      if (this.subscribelive != undefined) {
        this.subscribelive.unsubscribe();
      }

      if (this.subscribeeventdetail != undefined) {
        this.subscribeeventdetail.unsubscribe();
      }
    } catch (e) {
      console.log(e);
    }
  }

  getEventDetails(groupId = 2) {
    // this._ApiService.getEvent(this.eventid).then((x) => {
    //        if (x.length > 0)
    //            this.event = x[0];
    //    });
    //
    //    this._ApiService.getEventDetails(this.eventid, groupId).then((x) => {
    //        this.eventdetailList = x;
    //    });
  }

  marketTypeChanged(e) {
    this.selectedMarketValue = e;

    if (this.selectedMarketValue != 2) {
      this.eventdetailList = this.eventdetailListOriginal.filter(s => s.IsChanged == this.selectedMarketValue);
    } else {
      this.eventdetailList = this.eventdetailListOriginal;
    }

    //this._changeDetection.detectChanges();

    // this.getEventDetails(e);
  }

  clickOdd(e) {
    const newodd = {
      OddId: e.OddId,
    };

    //const index = this._ApiService.slipCurrents.findIndex((v) => {
    //  return v.OddId == e.OddId;
    //});
    //if (index > -1) {
    //  this._selectedOdds = this._selectedOdds.splice(index, 1);
    //} else {
    //  this._selectedOdds.push(newodd);
    //}

    this._ApiService.addLiveOdd(e.OddId);
  }

  checkOddId(oddId) {
    const index = this._ApiService.slipCurrents.findIndex(v => {
      return v.OddId1 == oddId;
    });
    if (index > -1) {
      return 'active';
    } else {
      return '';
    }
  }

  reverse(e) {
    if (e.indexOf(':') > -1) {
      return e.split(':')[1] + ':' + e.split(':')[0];
    } else return e;
  }

  removeBetValue(e) {
    return e.GroupName.replace(e.sbv, '');
  }

  eventDetailTabItemChange(tabId: number) {
    this.eventDetailTabItemSelected = tabId;

    if (tabId != undefined) this.getEventDetails(tabId);
  }
  goBack() {
    let iseventİd = 0;
    this.route.params.subscribe(params => {
      iseventİd = params['eventid'];
    });
    if (iseventİd != undefined && iseventİd != 0) {
      this._location.back();
    } else {
      this._UiHelper.b3000SetMatchDetailDialog('close');
      // this.ngOnDestroy();
    }
  }

  addMatch2Favs(): void {
    this.isFavorite = !this.isFavorite;
    const e = this._DataHelper.selectedMatch;

    if (e['matchfavourited'] != undefined) e['matchfavourited'] = true;
    else e['matchfavourited'] = !e['matchfavourited'];

    if (e['type'] != undefined && e['type'] == 'Match') {
      this._UserHelper.toogleFavoried(e['BetradarMatchId']);
    } else this._UiHelper.favPreMatchChanged(e);
  }

  openHeadToHeadDialog(): void {
    const bID = this.event.BetradarMatchId < 0 ? this.event.BetradarMatchId * -1 : this.event.BetradarMatchId;
    const dialogRef = this.dialog.open(HeadToHeadDialog, {
      maxWidth: '100%',
      width: '100%',
      height: '95%',
      maxHeight: '95%',
      panelClass: 'h2hDialogClass',
      // disableClose: true,
      data: { matchId: this.event.BetradarMatchId },
    });
    dialogRef.afterClosed().subscribe();
  }
}
